// Loop-length helpers (docs/04 §4.3 loop-first, §4.3 multiples) — pure, tested.

export const LAYER_MULTIPLES = [1, 2, 4] as const;
export type LayerMultiple = (typeof LAYER_MULTIPLES)[number];

/** Snap a measured recording duration to the nearest whole number of bars. */
export function snapDurationToBars(durationSec: number, bpm: number, beatsPerBar = 4): number {
  const barSec = (beatsPerBar * 60) / bpm;
  if (barSec <= 0) return 1;
  return Math.max(1, Math.round(durationSec / barSec));
}

/** Tone loop-end notation for `bars * multiple` bars. */
export function multipleLoopEnd(bars: number, multiple: LayerMultiple): string {
  return `${bars * multiple}m`;
}
